(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    const initVitavaProductMediaRail = (scope = document) => {
    scope.querySelectorAll('[data-vitava-media-rail]').forEach((rail) => {
      if (rail.dataset.vitavaRailReady === 'true') return;
      rail.dataset.vitavaRailReady = 'true';

      const gallery = rail.closest('media-gallery');
      if (!gallery) return;

      const thumbnails = [...rail.querySelectorAll('[data-vitava-media-thumb]')];
      const panels = [...gallery.querySelectorAll('[data-vitava-media-panel]')];

      const setActive = (mediaId) => {
        thumbnails.forEach((thumbnail) => {
          if (thumbnail.dataset.vitavaMediaThumb === mediaId) {
            thumbnail.setAttribute('aria-current', 'true');
          } else {
            thumbnail.removeAttribute('aria-current');
          }
        });
      };

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', (event) => {
          event.preventDefault();
          const mediaId = thumbnail.dataset.vitavaMediaThumb;
          const panel = gallery.querySelector(`[data-vitava-media-panel="${mediaId}"]`);
          panel?.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start',
          });
          setActive(mediaId);
        });
      });

      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (visible) setActive(visible.target.dataset.vitavaMediaPanel);
        },
        { rootMargin: '-20% 0px -55% 0px', threshold: [0.1, 0.5, 0.9] }
      );

      panels.forEach((panel) => observer.observe(panel));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initVitavaProductMediaRail());
  } else {
    initVitavaProductMediaRail();
  }

  document.addEventListener('shopify:section:load', (event) => initVitavaProductMediaRail(event.target));
  } catch(e) { console.error(e); }
})();

})();
